<template>
  <div>
    <CubePage type="myorder-view" title="出行管理">
      <div slot="content" class="content">
        <van-sticky :offset-top="44">
          <div class="cal-box">
            <div class="cal-sc">
              <div class="title" style="color: #323233">出行时间:</div>
              <div class="cals" @click="calshow = true">
                <span class="ri" v-if="row.use_date_start">{{ row.use_date_start }}</span>
                <span v-else style="color: #9e9e9e; font-size: 12px;">选择开始日期</span>
                <van-icon name="notes-o" size="20" />
              </div>
              <div class="dj">到</div>
              <div class="cals" @click="calshow = true">
                <span class="ri" v-if="row.use_date_end">{{ row.use_date_end }}</span>
                <span v-else style="color: #9e9e9e; font-size: 12px;">选择结束日期</span>
                <van-icon name="notes-o" size="20" />
              </div>
            </div>
          </div>
          <div class="tags tagsbtn">
            <van-button :class="selectcaltag == 'all' || selectcaltag == '' ? 'van-button-active' : ''"
              @click="onTagCalBtn('all')" plain round size="mini">全部</van-button>
            <van-button :class="selectcaltag == 'yesterday' ? 'van-button-active' : ''"
              @click="onTagCalBtn('yesterday')" plain round size="mini">昨天</van-button>
            <van-button :class="selectcaltag == 'today' ? 'van-button-active' : ''" @click="onTagCalBtn('today')" plain
              round size="mini">今天</van-button>
            <van-button :class="selectcaltag == 'tomorrow' ? 'van-button-active' : ''" @click="onTagCalBtn('tomorrow')"
              plain round size="mini">明天</van-button>
            <van-button :class="selectcaltag == 'last_week' ? 'van-button-active' : ''"
              @click="onTagCalBtn('last_week')" plain round size="mini">近1周</van-button>
            <van-button :class="selectcaltag == 'last_month' ? 'van-button-active' : ''"
              @click="onTagCalBtn('last_month')" plain round size="mini">近1月</van-button>
          </div>
          <!--<van-dropdown-menu active-color="#1989fa">
            <van-dropdown-item v-model="row.product_id" :options="productList" />
            <van-dropdown-item v-model="row.spec_sku_id" :options="skuList" />
          </van-dropdown-menu>
          <van-search placeholder="车牌号/司机/司机电话/游客/联系电话" v-model="row.search" @search="onSearch" show-action>
            <div slot="action" @click="onSearch">
              <van-button type="primary">搜索</van-button>
            </div>
          </van-search>-->
          <!--<van-search placeholder="车牌号/司机/司机电话" v-model="row.driver">
          </van-search>
          <van-search placeholder="游客/联系电话" v-model="row.tourist" @search="onSearch" show-action>
            <div slot="action" @click="onSearch">
              <van-button type="primary">搜索</van-button>
            </div>
          </van-search>-->
        </van-sticky>
        <div class="list-main" style="margin-top: 10px;">
          <van-empty v-if="isNoData" class="custom-image" description="暂无出行信息">
            <template #image>
              <img src="@/assets/img/empty.png" alt="">
            </template>
          </van-empty>
          <van-list v-else v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad()"
            :immediate-check="false">
            <div class="list-box">
              <div class="list-item" v-for="(item, index) in listData" :key="index">
                <div class="item-card">
                  <!--									<van-image class="card-img" round :src="item.avatar" />-->
                  <div class="card-content">
                    <div class="conten-title">
                      <p class="t ells">{{ item.product_name }}</p>
                      <div class="title-btns">
                        <span class="btn-text" @click="goDetail(item)">乘客</span>
                        <span class="btn-text" @click="goEdit(item)">编辑</span>
                        <span class="btn-text" @click="goDelete(item, index)">删除</span>
                      </div>
                    </div>
                    <div class="conten-desc ells">
                      <p style="color: #0d0d0d">
                        规格: <span style="padding-left: 5px;">{{ item.product_attr || '--' }}</span>
                      </p>
                    </div>
                    <div class="conten-desc">
                      <p>
                        车辆信息:<span style="padding-left: 5px;">{{ item.car || '--' }}</span>
                      </p>

                    </div>
                    <div class="conten-desc">
                      <p>
                        出行信息:<span style="padding-left: 5px;">{{ item.travel_time || '--' }}</span>
                      </p>
                      <p>
                        乘客/限载:<span style="padding-left: 5px;">{{ item.seat || '--' }}</span>
                      </p>
                    </div>
                    <div class="conten-desc">
                      <p style="color: red">
                        已核销:<span style="padding-left: 5px;">{{ item.use_num }}</span>
                      </p>
                      <p style="color: red">
                        未核销:<span style="padding-left: 5px;">{{ item.wait_num }}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
          <div class="btn">
            <van-button type="primary" @click="goNewShop">新增</van-button>
          </div>
        </div>
      </div>
    </CubePage>
    <van-calendar v-model="calshow" type="range" @confirm="onConfirm" :allow-same-day="true" :min-date="minDate" />
  </div>
</template>

<script>
import { Toast, Dialog } from 'vant';
import CubePage from '../../TP/cube-page.vue'
import * as util from '@/utils/network'
import * as udate from '@/utils/date'
import product from "@/components/LeoPages/supplier/Product.vue";
export default {
  computed: {
    product() {
      return product
    }
  },
  components: {
    CubePage
  },
  data() {
    return {
      selectcaltag: '',
      row: {
        search: "",
        driver: "",
        tourist: "",
        use_date_start: "",
        use_date_end: "",
        product_id: '',
        spec_sku_id: '',
      },
      calshow: false,
      minDate: new Date(2010, 0, 1),
      maxDate: new Date(),
      loading: false,
      finished: false,
      isNoData: false,
      listData: [],
      pageIndex: 1,
      pageTotal: 0,
      isSearch: false,
      productList: [{
        text: '产品选择',
        value: ''
      },

      ],
      skuList: [{
        text: '规格选择',
        value: ''
      }]
    }
  },
  created() {
    this.get_my_order()
    this.getTravelProductList()
    this.getTravelSkuList()
  },
  methods: {
    goDetail(item) {
      this.$router.push({
        path: '/supplier_travel_detail',
        query: {
          id: item.id
        }
      })
    },
    //拨打电话
    goPhone(e) {
      window.location.href = "tel://" + e;
    },
    onSearch() {
      this.clearContainer();
      this.isSearch = true;
      this.get_my_order();
    },
    // 上滑加载更多
    onLoad() {
      let that = this
      // if (this.isSearch && this.pageIndex == 1) {
      //   return false
      // }
      // 异步更新数据
      that.pageIndex++;
      setTimeout(() => {
        that.get_my_order();
      }, 1000)
    },
    getTravelProductList() {
      var url = "/addons/litestore/api.supplier/travelProductList"
      let that = this;
      //这里直接调用网络接口
      util.post(url, {},
        function (result) {
          // 将新数据与老数据进行合并
          // result.forEach(item => {
          //   item.value = item.text
          // })
          that.productList = that.productList.concat(result);

        },
      );
    },
    getTravelSkuList() {
      var url = "/addons/litestore/api.supplier/travelSkuList"
      let that = this;
      //这里直接调用网络接口
      util.post(url, {},
        function (result) {
          // 将新数据与老数据进行合并
          // result.forEach(item => {
          //   item.value = item.text
          // })
          that.skuList = that.skuList.concat(result);
        },
      );
    },
    get_my_order() {
      var url = "/addons/litestore/api.supplier/travelList"
      let that = this;
      console.log(that.row, 'that.row')
      //这里直接调用网络接口
      util.post(url, {
        page: that.pageIndex,
        product_id: that.row.product_id,
        spec_sku_id: that.row.spec_sku_id,
        search: that.row.search,
        driver: that.row.driver,
        tourist: that.row.tourist,
        travel_time_start: that.row.use_date_start,
        travel_time_end: that.row.use_date_end
      },
        function (result) {
          that.loading = false;
          //这里对状态 进行分类 
          that.pageTotal = result.total
          if (that.pageTotal < 1) {
            that.isNoData = true
            return;
          }
          if (result.rows == null || result.rows.length === 0) {
            // 加载结束
            that.finished = true;
            return;
          }
          // 将新数据与老数据进行合并
          that.listData = that.listData.concat(result.rows);

          //如果列表数据条数>=总条数，不再触发滚动加载
          if (that.listData.length >= that.pageTotal) {
            that.finished = true;
          }
        },
      );
    },
    // 初始化数据
    clearContainer() {
      this.loading = false
      this.finished = false
      this.listData = []
      this.isNoData = false
      this.pageIndex = 1
      this.pageTotal = 0
    },

    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    onConfirm(date) {
      let that = this;
      that.clearContainer();
      const [start, end] = date;
      that.calshow = false;
      that.row.use_date_start = that.formatDate(start);
      that.row.use_date_end = that.formatDate(end);
    },
    onTagCalBtn(v) {
      let that = this;
      this.clearContainer();
      if (that.selectcaltag == v) {
        that.row.use_date_end = '';
        that.row.use_date_start = '';
        that.selectcaltag = '';
        that.get_my_order();
        return;
      }
      //this.clearContainer();
      let start = '';
      let end = '';
      let fmt = 'yyyy-MM-dd'
      start = udate.getDatenow(fmt);
      switch (v) {
        case 'yesterday':
          start = that.GetDateStr(-1, fmt);
          end = start;
          break;
        case 'today':
          end = that.GetDateStr(0, fmt);
          break;
        case 'tomorrow':
          end = that.GetDateStr(+1, fmt);
          start = end;
          break;
        case 'last_week':
          end = start;
          start = that.GetDateStr(-7, fmt);
          break;
        case 'last_month':
          end = start;
          start = that.GetDateStr(-30, fmt);
          break;
        default:
          start = '';
          end = '';
          break;
      }
      that.row.use_date_start = start;
      that.row.use_date_end = end;
      that.selectcaltag = v
      that.listData = [];
      that.get_my_order();
    },
    GetDateStr(AddDayCount) {
      var day = new Date();
      day.setDate(day.getDate() + AddDayCount); //获取AddDayCount天后的日期
      var y = day.getFullYear();
      var m = day.getMonth() + 1; //获取当前月份的日期
      var d = day.getDate();
      m = String(m < 10 ? '0' + m : m);
      d = String(d < 10 ? '0' + d : d);
      return y + "-" + m + "-" + d;
    },
    goNewShop() {
      this.$router.push({
        path: '/supplier_travel_add'
      })
    },
    goEdit(item) {
      this.$router.push({
        path: '/supplier_travel_add',
        query: {
          id: item.id
        }
      })
    },
    goDelete(item, index) {
      Dialog.confirm({
        title: '确认删除',
        message: `确定要删除「${item.product_name}」吗？`,
      }).then(() => {
        Toast.loading({ message: '删除中...', forbidClick: true, duration: 0 });
        var url = "/addons/litestore/api.supplier/travelDel"
        util.post(url, {
          id: item.id
        },
          function (result) {
            if (result.code == 1) {
              this.listData.splice(index, 1);
              Toast.clear();
              Toast.success('删除成功');
            }
          },
        );
      }).catch(() => {});
    },
  }
}
</script>
<style lang="less">
@import url("../../../assets/css/order.css");
@import url("../../../assets/css/listboxless.less");
</style>
<style lang="less" type="text/css">
.van-sticky {
  background: #fafafa !important;
}
</style>
<style lang="less" scoped="scoped">
.van-search {
  padding: 5px 12px;
  ;

  .van-search__action {
    line-height: 0;
  }

  .van-button {
    height: 34px;
  }
}

.cal-box {
  background-color: #ffffff;

  .cal-sc {
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;

    .title {
      color: #989898;
      padding-right: 10px;
    }

    .dj {
      width: 30px;
      text-align: center;
      //margin: 0 5px;
    }

    .cals {
      flex: 1;
      text-align: center;

      .ri {
        font-weight: 600;
      }
    }

    // }
  }

}

.list-box {
  .list-item {
    margin-bottom: 10px;
    background-color: #FFFFFF;

    .item-card {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 20px 15px;
      box-sizing: border-box;

      .card-img {
        width: 60px;
        height: 60px;
      }

      .v {
        width: 20px;
      }

      .card-content {
        flex: 1;
        margin: 0 15px;

        .red-text {
          color: #d40000;
        }

        .conten-title {
          display: flex;
          justify-content: space-between;

          .t {
            //max-width: 140px;
            font-size: 16px;
            font-weight: 600;
          }

          .r {
            font-size: 14px;
          }
        }
        .title-btns {
          display: flex;
          gap: 12px;
          flex-shrink: 0;
          margin-left: 8px;

          .btn-text {
            font-size: 13px;
            color: #1989fa;
            white-space: nowrap;
          }
        }

        .conten-desc {
          padding-top: 8px;
          display: flex;
          justify-content: space-between;
          align-items: center;

          p {
            flex: 1;
            color: #a3a3a3;
            font-size: 14px;

            span {
              font-size: 13px;
            }
          }
        }
      }
    }

    .item-btns {
      height: 50px;
      display: flex;
      justify-content: space-around;
      align-items: center;

      .btn-item {

        .van-icon,
        .iconfont {
          vertical-align: middle;
          font-size: 20px;
        }

        .btn-text {
          font-size: 14px;
          padding: 0 5px;
        }
      }
    }
  }
}

.tagsbtn {
  margin: 15px;

  button {
    padding: 10px 15px;
  }

  .van-button-active {
    color: #55aaff;
  }
}

.list-main {
  padding-bottom: 60px;
}

.btn {
  position: fixed;
  bottom: 20px;
  right: 0;
  width: 100%;
  display: flex;

  .van-button {
    width: 80%;
    margin: 0 auto;
  }
}
</style>
